import { Button } from '@mui/material';
import styled, { css } from 'styled-components';
export const ModalContent = styled.section(({ theme }) => css `
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 380px;
    padding: 8px;
    padding-bottom: 20px;
    margin-left: auto;
    margin-right: auto;

    ${theme.breakpoints.down(400)} {
      min-width: 300px;
    }
  `);
export const CloseButtonWrapper = styled.div `
  display: flex;
  width: 100%;
  justify-content: right;
  align-items: center;
  padding-right: 5px;
  padding-top: 5px;
`;
export const NotificationContent = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
export const OkButton = styled(Button) `
  box-shadow: 0px 2px 15px rgba(52, 52, 176, 0.3);
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  text-transform: uppercase;
  font-weight: 600;
  width: 127px;
  height: 46px;
  ${({ theme }) => css `
    border-color: ${theme.palette.white.main};
    color: ${theme.palette.primary.main};
    font-size: ${theme.util.pxToRem(14)};

    &:hover {
      border-color: ${theme.palette.white.main};
    }
  `}
`;
export const TextWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-align: center;
`;
export const CheckboxWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-left: -25px;
  margin-top: -16px;
`;
export const RoomModalContent = styled.div `
  width: 490px;

  display: flex;
  flex-direction: column;

  padding: 32px;
  gap: 36px;

  border-radius: 8px;

  background-color: white;

  @media screen and (max-width: 480px) {
    padding: 16px;
    width: calc(100dvw - 16px);
  }
`;
export const StyledList = styled.ul `
  padding-left: 5px;
`;
export const StyledListItem = styled.li `
  position: relative;
  margin-bottom: 8px;
  padding-left: 20px;
  line-height: 1.4;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 8px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.palette.text.primary};
  }
`;
